import {isNotEmpty,isEmpty} from "./utils";
let resizingColumn = null;
let startX = null;
let startWidth = null;
let trEle = null;

let columnsArr = null;
let leftYlData = 0
function tableColResize(event,props,columns,otherParams={leftYl:0}){
    resizingColumn = props.col;
    startX = event.pageX;
    startWidth = event.srcElement.offsetParent.offsetWidth;
    trEle = event.srcElement.offsetParent;
    columnsArr = columns;
    leftYlData = otherParams.leftYl;
    document.addEventListener('mousemove', doResize);
    document.addEventListener('mouseup', stopResize);
}
function doResize(event){
    if (resizingColumn) {
        let newWidth = startWidth + (event.pageX - startX);
        let width = Math.max(10, newWidth)+'px';
        trEle.style.minWidth = width;
        trEle.style.width = width;
        trEle.style.maxWidth = width;
        let findCol = columnsArr.find(item=>{return item.field == resizingColumn.field});
        resizingColumn.style=('min-width:'+width);
        findCol.width = Math.max(10, newWidth);
        setColStyle({cols:columnsArr,leftYl:leftYlData})
        // findCol.style = 'min-width:'+width+';'+'max-width:'+width+';'+'width:'+width+';'
    }
}
function stopResize(){
    resizingColumn = null;
    startX = null;
    startWidth = null;
    trEle = null;
    columnsArr = null;
    document.removeEventListener('mousemove', doResize);
    document.removeEventListener('mouseup', stopResize);
}

function setColStyle({cols=[],leftYl=0}){
    cols.forEach(((col,index)=>{
        const style = {}
        const classes = [];
        if(isEmpty(col.width)){
            col.width = 90
        }
        // 处理左侧固定
        if (col.fixed === 'left') {
            style.position = 'sticky'
            style.zIndex = 2
            classes.push('emis-sticky-column','my-maximum-wrap-td')
            let widthAll = 0;
            let leftAccumulate = leftYl;
            cols.forEach((inCol,inIndex)=>{
                if(inIndex < index && inCol.fixed == 'left' && inCol.check){
                    if(isEmpty(inCol.width)){
                        inCol.width = 90
                    }
                    widthAll+=(inCol.width*1);
                }
            })
            leftAccumulate += widthAll;
            style.left = `${leftAccumulate}px`
        }
        // 处理右侧固定
        if (col.fixed === 'right') {
            style.position = 'sticky'
            style.zIndex = 2
            classes.push('emis-sticky-column','my-maximum-wrap-td')
            let widthAll = 0;
            let rightAccumulate = 0;
            cols.forEach((inCol,inIndex)=>{
                if(inIndex > index && inCol.fixed === 'right' && inCol.check){
                    if(isEmpty(inCol.width)){
                        inCol.width = 90
                    }
                    widthAll+=inCol.width*1;
                }
            })
            rightAccumulate += widthAll;
            style.right = `${rightAccumulate}px`
        }
        style['min-width']=`${col.width}px`;
        style['max-width']=`${col.width}px`;
        col.class = classes.join(' ');
        col.style = Object.entries(style).map(([k,v]) => `${k}:${v}`).join(';');
    }))
}
export {
    tableColResize,
    setColStyle
}
